import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpComponent } from './help/help.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HelpRoutingModule } from './help-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HelpCenterComponent } from './help-center/help-center.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
// import { ChaosSimulatorComponent } from '../chaos/chaos-simulator/chaos-simulator.component';

@NgModule({
  declarations: [HelpComponent, HelpCenterComponent],
  imports: [
    CommonModule,
    NgbModule,
    HelpRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    Ng2SearchPipeModule
  ]
})

export class HelpModule { }
